<template>
    <div>
        <table class="mt-4 table table-borderless">
            <tbody>
            <tr>
                <td class="w-25 p-1">
                    <p class="name text-secondary text-black-50 mt-4 mb-1">DOKUMENTMALL</p>
                </td>
                <td class="w-75 p-1">
                    <p class="name text-secondary text-black-50 mt-4 mb-1">OM MALLEN</p>
                </td>
            </tr>
            <tr>
                <td class="w-25 p-1">
                    <p class="title">Bolagsanalys</p>
                </td>
                <td class="w-75 p-1">
                    <p class="value">Dokumentet kan baseras på officiella bokslut eller en importerad SIE-fil.</p>
                    <p class="value">Presentationen inkluderar femårsöversikt, genomgång av detaljerad resultat- och balansräkning samt en bolagskompass. Avslutande kommentar är frivillig.</p>
                </td>
            </tr>
            </tbody>
        </table>

        <hr/>
        
        <table class="mt-4 mb-2 table table-borderless">
            <tbody>
            <tr>
                <td class="w-25 p-1">
                    <I name="aim" class="h1 mr-4 cSecondary"/>
                    <span class="h4">1. Välj bolag:</span>
                </td>
                <td class="w-75 p-1">
                    <CompanySelection
                        :locked="editing"
                        :disabled="editing"
                        :disabledSource="editing"
                        :company="company"
                        @company="selectedCompany = $event" 
                        @source="selectedSource = $event"
                        @branch="selectedBranch = $event" />
                </td>
            </tr>
            <tr>
                <td class="w-25 p-1">
                    <I name="bubble" class="h1 mr-4 cSecondary"/>
                    <span class="h4">2. Kommentera:</span>
                    <div class="h6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Skriv med fördel en kort och koncis kommentar</div>
                </td>
                <td class="w-75 p-1">
                    <div class="name text-secondary text-black-50 mb-1" style="opacity: 0.70;">KOMMENTAR</div>
                    <textarea :disabled="!selectedCompany || selected !== 'custom'" v-model="comment" class="w-100" style="height:200px;"></textarea>
                    <b-form-group :disabled="!selectedCompany">
                        <b-form-radio-group
                            v-model="selected"
                            :options="options"
                            @change="selectedChanged"
                            size="lg"
                            switches>
                        </b-form-radio-group>
                    </b-form-group>
                </td>
            </tr>
            </tbody>
        </table>

        <hr class="mt-4"/>

        <table class="mt-4 table table-borderless">
            <tbody>
            <tr>
                <td width="240px" class="p-0 pt-2">
                    <div @click="$emit('prev')" class="btn btn-outline-danger btn-block btn-lg cursor-pointer">
                        <template v-if="!editing">RADERA UTKAST</template>
                        <template v-else>AVBRYT ÄNDRINGAR</template>
                    </div>
                </td>
                <td class="h3 text-center">&nbsp;</td>
                <td width="240px" class="p-0 pt-2">
                    <div @click="create()" class="btn btn-outline-primary btn-block btn-lg cursor-pointer" :class="{disabled: !canCreate()}">
                        <template v-if="!editing">SKAPA DOKUMENT</template>
                        <template v-else>UPPDATERA DOKUMENT</template>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
/* tslint:disable */

    import ValueGroup from '@/views/ValueGroup.vue'
    import ValueSelection from '@/views/ValueSelection';
    import CompanySelection from '@/components/CompanySelection';
    import user from '@/store/modules/user';
    import * as api from '@/store/api';
	import Vue from 'vue';

    export default {
        name: "CreateDocumentCompany",
        components: {ValueSelection, ValueGroup, CompanySelection},
        props: {
            doc: Object,
        },
        data () {
            return {
                selectedCompany: undefined,
                selectedSource: undefined,
                selectedBranch: undefined,
                ranking: undefined,
                comment: '',
                selected: 'auto',
                options: [
                    {text: 'Automatisk kommentar', value: 'auto'},
                    {text: 'Egen kommentar', value: 'custom'},
                    {text: 'Ingen kommentar', value: 'no'},
                ],
                company: null,
                documentId: '',
            }
        },
        async mounted() {
            if (this.editing) {
                const c = await user.getCompany(this.doc.OrgNr);

                if (c) {
                    this.company = {
                        value: c.OrgNr,
                        label: c.Name,
                        Branch: this.doc.Bransch,
                        BranchText: this.doc.BranschText,
                        dateTo: c.DateTo,
                        SieAggVersion: this.doc.SieAggVersion,
                    };
                }

                this.selected = this.doc.CommentType;
                this.comment = this.doc.Comment;
            }
        },
        watch: {
            async selectedSource() {
                // console.log('SOURCE CHANGED');
                if (!this.selectedSource) {
                    this.comment = '';
                    return;
                }

                if (this.selectedSource.id === 0) {
                    this.ranking = await api.getRanking(user.version, this.selectedCompany.value);
                } else {
                    this.ranking = await api.getRankingSie(this.selectedSource.id, this.selectedCompany.value);
                }
                if (this.selected === 'auto') {
                    this.comment = this.ranking.sheets[0].comment;
                }
            },
        },
        methods: {
            selectedChanged(value) {
                // console.log('SELECTED CHANGED', value);
                if (value === 'no') {
                    this.comment = '';
                } else {
                    this.comment = this.ranking.sheets[0].comment;
                }
            },
            canCreate() {
                // console.log(this.selectedCompany, this.selectedSource, this.selectedBranch);
                return this.selectedCompany && this.selectedSource && this.selectedBranch;
            },
            async create() {
                if (!this.canCreate()) return;
                let OrgNr = this.selectedCompany.value;
                const doc = {
                    Type: 'company',
                    OrgNr: OrgNr,
                    BasedOn: this.selectedSource.source,
                    SieAggVersion: this.selectedSource.id,
                    Bransch: this.selectedBranch.id,
                    BranschText: this.selectedBranch.text,
                    CommentType: this.selected,
                    Comment: this.selected === 'auto' ? '' : this.comment,
                    DocumentId: this.editing ? this.doc.DocumentId : '',
                };
                if (this.editing) {
                    await api.updateDocument(doc);
                    await user.getUser('Uppdaterar dokument');
                } else {
                    await api.addDocument(doc);
                    await user.getUser('Skapar dokument');
                }
                this.$router.push({ name: 'documents', params: { OrgNr } });
            },
        },
        computed: {
            editing() {
                return this.$router.currentRoute.name === 'editdocument';
            },
        }
    }
</script>

<style scoped>
    .title {
        font-size: 1.5rem;
        font-weight: 600;
    }
    .name {
        font-size: 0.875rem;
        color: gray;
        text-transform: uppercase;
        font-weight: 400;
    }
    .value {
        font-size: 1.25rem;
        font-weight: 400;
    }
</style>
